(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[461],{

/***/ 2790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ ApplyButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ApplyButton_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(793);
/* harmony import */ var _ApplyButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ApplyButton_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _services_WindowService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2480);





const ApplyButton = (param)=>/*#__PURE__*/ {
    let { onClick  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>{
            onClick();
            _services_WindowService__WEBPACK_IMPORTED_MODULE_3__/* ["default"].animatedScrollTop */ .Z.animatedScrollTop();
        },
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("btn btn-dark", (_ApplyButton_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["apply-button"])),
        children: "Apply"
    });
};


/***/ }),

/***/ 5449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ FilterButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _FilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3954);
/* harmony import */ var _FilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_FilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_icons_FilterList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5963);





const FilterButton = (param)=>/*#__PURE__*/ {
    let { onClick  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("btn btn-small btn-dark fs-12px d-block d-md-none", (_FilterButton_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["filter-button"])),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_FilterList__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                style: {
                    fontSize: "14px",
                    verticalAlign: "sub",
                    marginRight: "8px"
                }
            }),
            "Filter"
        ]
    });
};


/***/ }),

/***/ 4461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ArtworksPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./services/utils/linksBuilder.js
var linksBuilder = __webpack_require__(3372);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./services/utils/isEmptyObject.js
var isEmptyObject = __webpack_require__(9657);
// EXTERNAL MODULE: ./services/utils/sorts.js
var sorts = __webpack_require__(7599);
// EXTERNAL MODULE: ./services/WindowService/index.js + 1 modules
var WindowService = __webpack_require__(2480);
// EXTERNAL MODULE: ./features/pages/ArtworksPage/utils/buildParams.js
var buildParams = __webpack_require__(6836);
// EXTERNAL MODULE: ./services/nodeApiService.js + 1 modules
var nodeApiService = __webpack_require__(9885);
;// CONCATENATED MODULE: ./features/pages/ArtworksPage/utils/callArtworksApi.js

const callArtworksApi = (params, gallery)=>{
    if (gallery) {
        return nodeApiService/* default.galleryArtworks */.Z.galleryArtworks(gallery.id, params);
    }
    return nodeApiService/* default.artworks */.Z.artworks(params);
};

// EXTERNAL MODULE: ./features/actions/useInfinitePagination.js
var useInfinitePagination = __webpack_require__(6578);
;// CONCATENATED MODULE: ./features/pages/ArtworksPage/utils/mapQueryParams.js
const findColorByName = (name, colors)=>{
    return colors.find((c)=>c.name.toLowerCase().replace("#", "") === name.replace("#", ""));
};
const findColorByValue = (value, colors)=>{
    return colors.find((c)=>c.id === value);
};
const findCatalogByName = (key, name, filters)=>{
    var _filters_key;
    var _c_name;
    return (_filters_key = filters[key]) === null || _filters_key === void 0 ? void 0 : _filters_key.find((c)=>((_c_name = c.name) !== null && _c_name !== void 0 ? _c_name : c.type).toLowerCase() === name.toLowerCase());
};
const findCatalogByValue = (key, value, filters)=>{
    var _filters_key;
    return (_filters_key = filters[key]) === null || _filters_key === void 0 ? void 0 : _filters_key.find((v)=>v.id === value);
};
/*
 * Retrieve filter query parameters from the URL
 */ const getQueryParams = function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, filters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for(const key in params){
        const value = params[key];
        switch(key){
            case "minHeight":
            case "maxHeight":
            case "minWidth":
            case "maxWidth":
                filter[key] = value;
                break;
            case "colors":
                if (Array.isArray(value)) {
                    let filteredColors = [];
                    value.forEach((colorName)=>{
                        let color = findColorByName(colorName, filters.colors);
                        if (color) filteredColors.push(color.id);
                    });
                    filter[key] = filteredColors;
                    break;
                }
                let color = findColorByName(value, filters.colors);
                if (color) filter[key] = [
                    color.id
                ];
                break;
            default:
                if (Array.isArray(value)) {
                    let filteredCatalog = [];
                    value.forEach((catalogName)=>{
                        let catalog = findCatalogByName(key, catalogName, filters);
                        if (catalog) filteredCatalog.push(catalog.id);
                    });
                    filter[key] = filteredCatalog;
                    break;
                }
                let catalog = findCatalogByName(key, value, filters);
                if (catalog) filter[key] = [
                    catalog.id
                ];
                break;
        }
    }
    return filter;
};
/*
 * Set filter query parameters in the URL
 */ const setQueryParams = function() {
    let filter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, router = arguments.length > 1 ? arguments[1] : void 0, filters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    let params = [];
    for(const key in filter){
        const values = filter[key];
        let paramValues = [];
        if (Array.isArray(values)) {
            values.forEach((value)=>{
                let paramValue = "colors" === key ? findColorByValue(value, filters.colors) : findCatalogByValue(key, value, filters);
                var _paramValue_name;
                if (paramValue) paramValues.push(((_paramValue_name = paramValue.name) !== null && _paramValue_name !== void 0 ? _paramValue_name : paramValue.type).toLowerCase().replace("#", ""));
            });
        } else {
            values && paramValues.push(values);
        }
        if (paramValues.length > 0) {
            params[key] = paramValues;
        }
    }
    if (router.query.id) params.id = router.query.id;
    filter && router.push({
        pathname: router.route,
        query: params
    }, undefined, {
        shallow: true
    });
};

;// CONCATENATED MODULE: ./features/actions/useArtworksAction.js









const totalFilters = (search)=>{
    return Object.keys(search).map((key)=>search[key]).filter((val)=>{
        return Array.isArray(val) ? val.length > 0 : !!val;
    }).length;
};
const useArtworksAction = (param)=>{
    let { catalogData , setCatalogData , gallery , filters  } = param;
    const router = (0,next_router.useRouter)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [firstRender, setFirstRender] = (0,react.useState)(true);
    const [showFilters, setShowFilters] = (0,react.useState)(false);
    const [queryFilters, setQueryFilters] = (0,react.useState)(false);
    const _sorts = sorts/* sorts.artworks */.L.artworks;
    const [sort, setSort] = (0,react.useState)("createddesc");
    const [search, setSearch] = (0,react.useState)({
        colors: [],
        collections: [],
        sizes: [],
        type: [],
        orientations: [],
        medium: [],
        material: [],
        minHeight: null,
        maxHeight: null,
        minWidth: null,
        maxWidth: null
    });
    const [collapses, setCollapses] = (0,react.useState)({
        collections: false,
        sizes: false,
        type: false,
        orientations: false,
        medium: false,
        material: false,
        dimensions: false,
        colors: false
    });
    const { setPage , setShouldCall  } = (0,useInfinitePagination/* useInfinitePagination */.J)((page)=>{
        if (queryFilters) {
            let params = (0,buildParams/* buildParams */.U)(search);
            return callArtworksApi({
                ...params,
                page
            }, gallery);
        }
    }, (response)=>setCatalogData({
            ...catalogData,
            data: [
                ...catalogData.data,
                ...response.data
            ]
        }));
    (0,react.useEffect)(()=>{
        if (queryFilters) {
            const params = (0,buildParams/* buildParams */.U)(search, sort);
            if (!(0,isEmptyObject/* isEmptyObject */.Q)(params)) {
                setLoading(true);
                callArtworksApi(params, gallery).then((response)=>{
                    setCatalogData(response.data);
                    setLoading(false);
                });
            } else if (!firstRender) {
                callCleanApi();
            }
        }
    }, [
        search,
        sort
    ]);
    (0,react.useEffect)(()=>{
        mapQueryFilters();
        setFirstRender(false);
    }, []);
    const clearFilters = ()=>{
        const initSearch = {
            colors: [],
            collections: [],
            sizes: [],
            shapes: [],
            orientations: [],
            medium: [],
            material: [],
            minHeight: null,
            maxHeight: null,
            minWidth: null,
            maxWidth: null
        };
        setSearch(initSearch);
        setQueryParams(initSearch, router, filters);
    };
    const callCleanApi = ()=>{
        setPage(1);
        setShouldCall(true);
        WindowService/* default.animatedScrollTop */.Z.animatedScrollTop();
        setLoading(true);
        callArtworksApi(null, gallery).then((response)=>{
            setCatalogData(response.data);
            setLoading(false);
        });
    };
    const onClickString = (key, value)=>{
        search[key] = value;
        setSearch({
            ...search
        });
        setQueryParams({
            ...search
        }, router, filters);
    };
    const onClickArray = (key, value)=>{
        const index = search[key].indexOf(value);
        if (index === -1) {
            search[key].push(value);
        } else {
            search[key].splice(index, 1);
        }
        setSearch({
            ...search
        });
        setQueryParams({
            ...search
        }, router, filters);
    };
    const onClickItem = (key, value)=>{
        if ([
            "minHeight",
            "maxHeight",
            "minWidth",
            "maxWidth"
        ].includes(key)) {
            return onClickString(key, value);
        }
        return onClickArray(key, value);
    };
    const mapQueryFilters = ()=>{
        let filterParams = getQueryParams(router.query, {
            ...search
        }, filters);
        setSearch(filterParams);
        setQueryFilters(true);
    };
    const toggleExpand = (key)=>{
        const _collapses = collapses;
        _collapses[key] = !_collapses[key];
        setCollapses({
            ..._collapses
        });
    };
    return {
        loading,
        setLoading,
        search,
        setSearch,
        collapses,
        setCollapses,
        clearFilters,
        onClickItem,
        toggleExpand,
        totalFilters: totalFilters(search),
        showFilters,
        setShowFilters,
        sort,
        setSort,
        sorts: _sorts
    };
};

// EXTERNAL MODULE: ./features/components/GalleryHeader/index.js
var GalleryHeader = __webpack_require__(1115);
// EXTERNAL MODULE: ./features/components/Layout/Container/index.js
var Container = __webpack_require__(1286);
// EXTERNAL MODULE: ./features/components/Layout/HeadingTitle/index.js
var HeadingTitle = __webpack_require__(8434);
// EXTERNAL MODULE: ./features/components/Layout/HelmetTitle/index.js
var HelmetTitle = __webpack_require__(6470);
// EXTERNAL MODULE: ./features/components/Layout/MobileMenu/index.js
var MobileMenu = __webpack_require__(8127);
// EXTERNAL MODULE: ./features/components/Layout/SearchSortHeader/index.js + 3 modules
var SearchSortHeader = __webpack_require__(8984);
// EXTERNAL MODULE: ./features/components/Layout/Wrapper/index.js
var Wrapper = __webpack_require__(1350);
// EXTERNAL MODULE: ./features/components/LeftSide/index.js + 2 modules
var LeftSide = __webpack_require__(6722);
// EXTERNAL MODULE: ./features/components/Layout/Loader/index.js
var Loader = __webpack_require__(9542);
// EXTERNAL MODULE: ./features/components/Masonry/index.js
var Masonry = __webpack_require__(3827);
// EXTERNAL MODULE: ./features/pages/ArtworksPage/ApplyButton.js
var ApplyButton = __webpack_require__(2790);
// EXTERNAL MODULE: ./features/pages/ArtworksPage/FilterButton.js
var FilterButton = __webpack_require__(5449);
// EXTERNAL MODULE: ./features/pages/ArtworksPage/ArtworksPage.module.scss
var ArtworksPage_module = __webpack_require__(2129);
var ArtworksPage_module_default = /*#__PURE__*/__webpack_require__.n(ArtworksPage_module);
// EXTERNAL MODULE: ./features/components/Layout/SeoTags/index.js
var SeoTags = __webpack_require__(7182);
// EXTERNAL MODULE: ./features/providers/AppProvider.js
var AppProvider = __webpack_require__(2674);
// EXTERNAL MODULE: ./features/actions/useContactAction.js
var useContactAction = __webpack_require__(5419);
// EXTERNAL MODULE: ./features/components/GalleryContactModal/index.js
var GalleryContactModal = __webpack_require__(7538);
// EXTERNAL MODULE: ./services/utils/getArtworkSize.js
var getArtworkSize = __webpack_require__(731);
// EXTERNAL MODULE: ./services/utils/getArtworkTitle.js
var getArtworkTitle = __webpack_require__(194);
// EXTERNAL MODULE: ./services/utils/getArtworkSubtitle.js
var getArtworkSubtitle = __webpack_require__(9296);
// EXTERNAL MODULE: ./services/utils/formatPrice.js
var formatPrice = __webpack_require__(1479);
// EXTERNAL MODULE: ./features/components/NewsletterGalleries/index.js + 1 modules
var NewsletterGalleries = __webpack_require__(1750);
;// CONCATENATED MODULE: ./features/pages/ArtworksPage/index.js





























const Artworks = (param)=>{
    let { catalog , gallery , filters  } = param;
    const { profile  } = (0,AppProvider/* useAppContext */.b)();
    const [catalogData, setCatalogData] = (0,react.useState)(catalog);
    const { loading , search , collapses , clearFilters , onClickItem , toggleExpand , totalFilters , showFilters , setShowFilters , sort , setSort , sorts  } = useArtworksAction({
        catalogData,
        setCatalogData,
        gallery,
        filters
    });
    const { form , setForm , onSubmit , handleShow , handleClose , modal , success , error , errorMessage , onReCAPTCHAChange , recaptchaRef , loadingContact  } = (0,useContactAction/* useContactAction */.J)(gallery);
    const LoadedElements = ()=>{
        if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {});
        const items = catalogData.data.map((item)=>{
            var _item_gallery, _item_gallery1;
            return {
                to: linksBuilder/* linksBuilder.artworks */.m.artworks((_item_gallery = item.gallery) === null || _item_gallery === void 0 ? void 0 : _item_gallery.domain, item.id, item.title),
                href: "/galleries/[id]/artworks/[artwork]",
                title: (0,getArtworkTitle/* getArtworkTitle */.H)(item.title),
                image: item.image,
                subtitle: (0,getArtworkSubtitle/* getArtworkSubtitle */.z)(item.artistname, (_item_gallery1 = item.gallery) === null || _item_gallery1 === void 0 ? void 0 : _item_gallery1.name),
                subSubTitle: (0,getArtworkSize/* getArtworkSize */.Y)(item.width, item.height),
                sold: item.sold,
                price: item.price ? item.gallery.currency.symbol + " " + (0,formatPrice/* formatPrice */.T)(item.price) : null,
                textAlign: "left"
            };
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Masonry/* Masonry */.R, {
            id: "artworks",
            items: items
        });
    };
    const Header = ()=>{
        if (gallery) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryHeader/* GalleryHeader */.g, {
                galleryDetails: gallery,
                onClickContact: handleShow
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: 12,
                md: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingTitle/* HeadingTitle */.E, {
                    title: "Artworks",
                    children: "Discover fine art paintings, posters, prints, drawings and photographs from the comfort of your home."
                })
            })
        });
    };
    const Filters = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSide/* default */.Z, {
            search: search,
            collapses: collapses,
            clearFilters: clearFilters,
            onClickItem: onClickItem,
            toggleExpand: toggleExpand,
            totalFilters: totalFilters,
            filters: filters
        });
    // Discover Profile statement; fall back to the Artist Info statement when empty.
    const statement = gallery && (gallery.discover_statement || gallery.statement);
    var _c_label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* SeoTags */.o, {
                title: "Artworks | Discover ArtPlacer",
                description: "Discover fine art paintings, posters, prints and photographs from the comfort of your home.",
                url: "https://discover.artplacer.com/artworks",
                canonical: "https://discover.artplacer.com/".concat(gallery ? "galleries/".concat(gallery.domain, "/") : "", "artworks")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelmetTitle/* HelmetTitle */.i, {
                title: "Artworks"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: "justify-content-center text-black fs-15px fs-mobile-14px",
                            children: [
                                profile.embedded && statement && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            lg: 8,
                                            md: 8,
                                            sm: 10,
                                            xs: 11,
                                            className: "my-sm-1 my-md-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-0 word-wrap-break font-weight-light text-black lh-17 ws-pw text-container ".concat(statement.length > 1000 ? "two-columns" : ""),
                                                children: statement
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "w-100 mx-3 mt-4 mb-2 pb-0"
                                        })
                                    ]
                                }),
                                profile.embedded && gallery.collections.length > 0 && gallery.collections.length < 80 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                            className: "mx-2 my-3 w-100",
                                            children: gallery.collections.map((c)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    sm: "4",
                                                    md: "3",
                                                    className: "text-capitalize text-truncate font-weight-light mb-3 fs-15px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        style: {
                                                            color: "black",
                                                            lineHeight: "1.2",
                                                            whiteSpace: "pre"
                                                        },
                                                        href: linksBuilder/* linksBuilder.collections */.m.collections(gallery.id, c.collection),
                                                        children: (_c_label = c.label) !== null && _c_label !== void 0 ? _c_label : c.collection
                                                    })
                                                }))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "w-100 mx-3 mt-2 mb-4 pb-0"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: "py-4",
                            children: [
                                !profile.embedded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    sm: 12,
                                    md: 2,
                                    className: "d-none d-md-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    sm: 12,
                                    md: !profile.embedded ? 10 : 12,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSortHeader/* SearchSortHeader */.y, {
                                            hideSearch: true,
                                            title: "",
                                            sort: sort,
                                            setSort: setSort,
                                            sorts: sorts,
                                            children: !profile.embedded && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* FilterButton */.L, {
                                                onClick: ()=>setShowFilters(true)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadedElements, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryContactModal/* GalleryContactModal */.X, {
                            form: form,
                            setForm: setForm,
                            galleryDetails: gallery,
                            modal: modal,
                            onSubmit: onSubmit,
                            handleClose: handleClose,
                            error: error,
                            errorMessage: errorMessage,
                            success: success,
                            recaptchaRef: recaptchaRef,
                            onReCAPTCHAChange: onReCAPTCHAChange
                        }),
                        gallery && gallery.domain !== "pinta-baphoto" && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterGalleries/* default */.Z, {
                            gallery: gallery
                        })
                    ]
                })
            }),
            showFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu/* default */.Z, {
                className: (ArtworksPage_module_default())["mobile-menu-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((ArtworksPage_module_default())["filter-mobile"], "position-relative"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplyButton/* ApplyButton */.V, {
                            onClick: ()=>setShowFilters(false)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ArtworksPage = (Artworks);


/***/ }),

/***/ 6836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ buildParams; }
/* harmony export */ });
/* harmony import */ var _services_utils_getQueryStringValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4694);

const buildParams = (search, sort)=>{
    const { colors , sizes , type , orientations , medium , material , minHeight , maxHeight , minWidth , maxWidth  } = search;
    const queryStringValue = (0,_services_utils_getQueryStringValue__WEBPACK_IMPORTED_MODULE_0__/* .getQueryStringValue */ .j)("search");
    let params = {};
    if (sizes.length > 0) {
        params["size"] = sizes;
    }
    if ((type === null || type === void 0 ? void 0 : type.length) > 0) {
        params["type"] = type;
    }
    if (orientations.length > 0) {
        params["orientation"] = orientations;
    }
    if (medium.length > 0) {
        params["medium"] = medium;
    }
    if (material.length > 0) {
        params["material"] = material;
    }
    if (colors.length > 0) {
        params["colorsfilter"] = colors;
    }
    if (minHeight && minHeight > 0) {
        params["minh"] = minHeight;
    }
    if (maxHeight && maxHeight > 0) {
        params["maxh"] = maxHeight;
    }
    if (minWidth && minWidth > 0) {
        params["minw"] = minWidth;
    }
    if (maxWidth && maxWidth > 0) {
        params["maxw"] = maxWidth;
    }
    if (sort) {
        params["order"] = sort;
    }
    if (!!queryStringValue) {
        params["search"] = queryStringValue;
    }
    return params;
};


/***/ }),

/***/ 793:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"apply-button":"ApplyButton_apply-button__BeJ0c"};

/***/ }),

/***/ 2129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobile-menu-container":"ArtworksPage_mobile-menu-container__PIHn3","filter-mobile":"ArtworksPage_filter-mobile__c60J7"};

/***/ }),

/***/ 3954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filter-button":"FilterButton_filter-button__n3mXH"};

/***/ })

}]);